import React, { useEffect } from "react";
import { useForm } from "hooks";
import { formatCurrency } from "services/util";
import { Trans } from "react-i18next";
import moment from "moment";
import { Table, Button } from "reactstrap";
import classNames from "classnames";
import { NotificationManager } from "react-notifications";
import { actions } from "react-redux-form";
import { Page } from "components/common";

const formatDate = (v) => moment(v).format("DD MMM YYYY");

const PayRunStatus = ({ status }) => (
  <div
    className={classNames(
      "d-inline-block border rounded px-2 small",
      {
        "border-warning text-warning": status === "Draft",
      },
      { "border-info text-info": status === "Approved" },
      { "border-success text-success": status === "Paid" }
    )}
  >
    <Trans>{status}</Trans>
  </div>
);

function ApproveButton(props) {
  const status = props.status;
  if (status === "Draft") {
    return (
      <div className="d-flex justify-content-end">
        <Button color="success" onClick={props.onSubmit}>
          <Trans>Approve</Trans>
        </Button>
      </div>
    );
  }
  return null;
}

function PaymentButton(props) {
  const status = props.status;
  if (status === "Approved") {
    return (
      <div className="d-flex justify-content-end">
        <Button color="success" onClick={props.onSubmit}>
          <Trans>Make payment</Trans>
        </Button>
      </div>
    );
  }
  return null;
}

function VoidButton(props) {
  const status = props.status;
  if (status === "Draft") {
    return (
      <div className="d-flex justify-content-start">
        <Button color="danger" onClick={props.onVoid}>
          <Trans>Delete Payrun</Trans>
        </Button>
      </div>
    );
  }
  return null;
}

export const View = ({
  model = "local",
  match,
  payroll,
  url = "pay_runs",
  client,
  history,
  t,
  xero,
}) => {
  const { id } = match.params;

  const { dispatch, setValue, value, load } = useForm({
    model,
  });

  useEffect(() => {
    async function fetchData() {
      const [item] = await Promise.all([
        load(payroll, url, id, {
          end_date: "",
          month: "",
          start_date: "",
          status: "",
          total_cost: "",
          total_pay: "",
          year: "",
        }),
      ]);

      setValue(item);
    }
    fetchData();
  }, [id]);

  async function onSubmit() {
    let status = value["status"];
    if (status === "Draft") {
      value["status"] = "Approved";
      try {
        await payroll.post(`pay_runs/${value.id}/approve`);
        NotificationManager.success(t("Saved successfully"));
        history.replaceUp();
      } catch (ex) {
        NotificationManager.error(t("Error occurred"));
      } finally {
        dispatch(actions.setPending(model, false));
      }
    }
  }

  async function onMakePayment() {
    await client.get(
      `payroll/${value.connected_organisation}/pay_runs/${value.id}/make_payment`
    );
    history.replace("/payroll/pay_runs");
  }

  async function onVoid() {
    await client.delete(
      `payroll/${value.connected_organisation}/pay_runs/${value.id}`
    );
    history.replace("/payroll/pay_runs");
  }

  return (
    <Page title={t("Summary")} className="inv-table">
      <Table>
        <thead>
          <tr>
            <th>
              <Trans>Pay Period</Trans>
            </th>
            <th>
              <Trans>Total Cost</Trans>
            </th>
            <th>
              <Trans>Total Pay</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr key={value.id}>
            <td>
              {formatDate(value.start_date)} - {formatDate(value.end_date)}
            </td>
            <td>{formatCurrency(value.total_cost)}</td>
            <td>{formatCurrency(value.total_pay)}</td>
            <td>
              <PayRunStatus status={value.status} />
            </td>
          </tr>
        </tbody>
      </Table>
      <div className="row">
        <div className="col-sm-6">
          <VoidButton status={value.status} onVoid={onVoid} />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <PaymentButton status={value.status} onSubmit={onMakePayment} />
          <ApproveButton status={value.status} onSubmit={onSubmit} />
        </div>
      </div>
    </Page>
  );
};

export default View;
